export const ORDER_CONFIRMATIONS = "orderConfirmations";
export const ORDER_UPDATES = "orderUpdates";
export const TRACK_AND_TRACE = "trackAndTrace";
export const INVOICES = "invoices";
export const MARKETING_MESSAGES = "marketingMessages";

export const COMMUNICATION_TYPES = [
  {
    label: "order_confirmations",
    value: ORDER_CONFIRMATIONS,
  },
  {
    label: "order_updates",
    value: ORDER_UPDATES,
  },
  {
    label: "track_and_trace",
    value: TRACK_AND_TRACE,
  },
  {
    label: "invoices",
    value: INVOICES,
  },
  {
    label: "marketing_messages",
    value: MARKETING_MESSAGES,
  },
];
